module.exports = __webpack_public_path__ + "img/baht_unit.e63f24f9.svg";